import { Colors, Icon, Text } from '@amelio/ui-library';

import { Bone, Skeleton } from '@/components/Skeleton/Skeleton';

export interface AgendaGeneratingNotice {
    title: string;
    message: string;
}

interface AgendaGeneratingStateProps {
    /** Said above the skeleton while the AI writes the agenda. Left out, the skeleton stands alone,
     * the way an agenda still loading reads. */
    notice?: AgendaGeneratingNotice;
}

/** An agenda not there yet: a skeleton in its place, and what is happening when the AI writes it. */
export const AgendaGeneratingState = ({ notice }: AgendaGeneratingStateProps) => (
    <div className={'space-y-4'}>
        {notice && (
            <div className={'flex items-center gap-3'}>
                <div
                    className={
                        'bg-primary-50 flex h-11 w-11 shrink-0 items-center justify-center rounded-full'
                    }
                >
                    <Icon
                        name={'lucide-sparkles'}
                        size={'md'}
                        color={Colors.PRIMARY}
                    />
                </div>
                <div>
                    <Text
                        weight={'semibold'}
                        color={Colors.BASE_600}
                    >
                        {notice.title}
                    </Text>
                    <Text
                        size={'small'}
                        color={Colors.BASE_400}
                    >
                        {notice.message}
                    </Text>
                </div>
            </div>
        )}
        <Skeleton>
            <div className={'space-y-4'}>
                <Bone className={'h-6 w-40'} />
                <Bone className={'h-24 w-full'} />
                <Bone className={'h-32 w-full'} />
            </div>
        </Skeleton>
    </div>
);
